import {Pipe, PipeTransform} from '@angular/core';
import {GalleryModel} from '../../types/types';

@Pipe({name: 'galleryLink'})
export class GalleryLinkPipe implements PipeTransform {
  transform(gallery: GalleryModel): string {
    return `/gallery/${gallery.registry.slug}/${gallery.slug}`;
  }
}
